import React from 'react';
import ContactDetails from '../../components/contactUsPage/contactDetails/contactDetails';
import Title from '../../components/containers/title/title';
import classes from '../../components/contactUsPage/contactUs.module.css';
import Form from '../../components/contactUsPage/form/form';
const ContactUs = () => {
    return (
        <div className={classes.Container}>
            <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'GET IN TOUCH' : 'تواصل معنا'}/>
            <ContactDetails />
            <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'SEND US A MESSAGE' : 'أرسل لنا رسالة'}/>
            <Form/>
        </div>
    )
}
export default ContactUs;